import { Link, createFileRoute } from "@tanstack/react-router";

import IntegrationsSettings from "@/components/IntegrationsSettings";
import { AppHeader } from "@/components/app-header";
import { RequireAuth } from "@/components/route-guards";
import { useAuth } from "@/lib/auth";
import { signOut } from "@/lib/platform-fetch";

/**
 * `/settings/integrations` -- per-user OAuth connections.
 *
 * Replaces `src/app/settings/integrations/page.tsx`. That page hand-rolled its own signed-out
 * branch, rendering a "Sign in with Okta" button behind a Server Action; `RequireAuth` now owns
 * that for every authenticated route, so the two cannot drift into behaving differently.
 *
 * `hasAdminAccess` came from a server-side `hasAnyAdminAccess(userId)` call per render. It is
 * one field on `/v1/me` now, already in the auth context, so the header costs no extra request.
 */
export const Route = createFileRoute("/settings/integrations")({
  component: IntegrationsRoute,
});

function IntegrationsRoute() {
  return (
    <RequireAuth>
      <IntegrationsPage />
    </RequireAuth>
  );
}

function IntegrationsPage() {
  const { user, hasAdminAccess, skillsEnabled } = useAuth();

  return (
    <main className="flex min-h-dvh flex-col">
      <AppHeader
        left={<Link to="/">&larr; Back to chat</Link>}
        userLabel={user?.email ?? user?.name ?? "unknown"}
        hasAdminAccess={hasAdminAccess}
        skillsEnabled={skillsEnabled}
        signOutAction={signOut}
      />
      <IntegrationsSettings />
    </main>
  );
}
